/**
 * InterviewFlow City Hall brand tokens — shared by landing + citizen demos.
 * Keep Public Sector CSS vars in sync (publicSector/frontend/src/styles/interviewflow-brand.css).
 */

export const IF_BRAND = {
  ink: '#0c1a2e',
  accent: '#1976d2',
  accentDark: '#1565c0',
  warm: '#e8913a',
  stone: '#8a9bb0',
  paper: '#ffffff',
  canvas: '#eef2f7',
  mist: '#f4f7fb',
  display: '"Fraunces", Georgia, serif',
  body: '"Source Sans 3", "Source Sans Pro", system-ui, sans-serif',
  headerGradient:
    'linear-gradient(105deg, color-mix(in srgb, #1976d2 14%, #fff) 0%, #f4f7fb 45%, #fff 100%)',
  shellWash:
    'radial-gradient(ellipse 80% 50% at 10% -10%, color-mix(in srgb, #1976d2 16%, transparent), transparent 55%)',
  fontHref:
    'https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,500;9..144,600;9..144,700&family=Source+Sans+3:wght@400;600;700&display=swap',
};

const FONT_LINK_ID = 'interviewflow-cityhall-fonts';

export function ensureInterviewFlowFonts() {
  if (typeof document === 'undefined') return;
  if (document.getElementById(FONT_LINK_ID)) return;
  const link = document.createElement('link');
  link.id = FONT_LINK_ID;
  link.rel = 'stylesheet';
  link.href = IF_BRAND.fontHref;
  document.head.appendChild(link);
}

/** CSS custom properties for MUI sx / inline styles */
export function interviewFlowCssVars(primary = IF_BRAND.accent) {
  return {
    '--citizen-primary': primary,
    '--if-ink': IF_BRAND.ink,
    '--if-accent': primary,
    '--if-warm': IF_BRAND.warm,
    '--if-stone': IF_BRAND.stone,
    '--if-canvas': IF_BRAND.canvas,
    '--if-mist': IF_BRAND.mist,
  };
}
